import { RadioGroupItem } from '@dreryk/react-components';

import { historicalLeavesTranslationKeys } from '../../../../../translations';

import { MedicalLeaveZlaPrintType } from './ForeignInsuredPrintModal.types';

export const DEFAULT_MEDICAL_LEAVE_ZLA_PRINT_TYPE: MedicalLeaveZlaPrintType = 'COPY';

export const MEDICAL_LEAVE_ZLA_PRINT_TYPE_ITEMS: RadioGroupItem<MedicalLeaveZlaPrintType>[] = [
   {
      id: 'COPY',
      label: historicalLeavesTranslationKeys.foreignInsuredPrintModal.copyWithoutIcd10,
   },
   {
      id: 'ORIGINAL',
      label: historicalLeavesTranslationKeys.foreignInsuredPrintModal.originalWithIcd10,
   },
];
